"use client";

import { useState } from "react";
import Link from "next/link";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon";
import { Button } from "@/components";

const QUADRANTS = ["NW CALGARY", "NE CALGARY", "SW CALGARY", "SE CALGARY"] as const;

const NEIGHBORHOODS: Record<(typeof QUADRANTS)[number], string[]> = {
  "NW CALGARY": [
    "Parkland Beach",
    "Sunset Point",
    "Half Moon Bay",
    "Island Lake South",
    "Ma-Me-O Beach",
    "Whispering Hills",
    "Black Diamond",
    "Waiparous",
    "Parkland Beach",
    "Castle Island",
    "Whispering Hills",
    "Lac la Biche",
    "Fort Macleod",
    "Mayerthorpe",
    "Drayton Valley",
    "Brownvale",
  ],
  "NE CALGARY": [
    "Parkland Beach",
    "Castle Island",
    "Whispering Hills",
    "Lac la Biche",
    "Fort Macleod",
    "Mayerthorpe",
    "Drayton Valley",
    "Brownvale",
    "Parkland Beach",
    "Castle Island",
    "Whispering Hills",
    "Lac la Biche",
    "Fort Macleod",
    "Mayerthorpe",
    "Drayton Valley",
    "Brownvale",
  ],
  "SW CALGARY": [
    "Parkland Beach",
    "Castle Island",
    "Whispering Hills",
    "Lac la Biche",
    "Fort Macleod",
    "Mayerthorpe",
    "Drayton Valley",
    "Brownvale",
    "Parkland Beach",
    "Castle Island",
    "Crowsnest Pass",
    "Sunbreaker Cove",
    "Red Deer",
    "Sundance Beach",
    "Norris Beach",
    "Wood Buffalo",
  ],
  "SE CALGARY": [
    "Parkland Beach",
    "Castle Island",
    "Crowsnest Pass",
    "Sunbreaker Cove",
    "Red Deer",
    "Sundance Beach",
    "Norris Beach",
    "Wood Buffalo",
    "Whispering Hills",
    "Lac la Biche",
    "Fort Macleod",
    "Mayerthorpe",
    "Drayton Valley",
    "Brownvale",
    "Parkland Beach",
    "Castle Island",
  ],
};

export default function WhereWeDeliverSection() {
  const [tab, setTab] = useState<(typeof QUADRANTS)[number]>("NW CALGARY");
  const items = NEIGHBORHOODS[tab];

  const COL_COUNT = 6;
  const perCol = Math.ceil(items.length / COL_COUNT);
  const columns: string[][] = [];
  for (let i = 0; i < COL_COUNT; i++) {
    columns.push(items.slice(i * perCol, (i + 1) * perCol));
  }

  return (
    <section className="w-full max-w-none" aria-labelledby="where-heading">
      <div className="w-full">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <h2
            id="where-heading"
            className="text-h3-mobile sm:text-h3-desktop font-bold text-text-primary"
          >
            Where do we deliver?
          </h2>
          <p className="max-w-md text-body-16-desktop font-medium text-text-secondary lg:text-right">
            City Wide! Here&apos;s a list of the Calgary quadrants we serve with
            our same-day Calgary weed delivery service
          </p>
        </div>

        <div className="mt-6 overflow-hidden rounded-2xl border border-neutral-10 bg-constant-white">
          {/* Tab bar, full width equal segments */}
          <div className="border-b border-neutral-10 p-4">
            <div className="flex overflow-x-auto scrollbar-hide rounded-xl sm:grid sm:grid-cols-4 sm:overflow-visible gap-1">
              {QUADRANTS.map((q) => {
                const active = tab === q;
                return (
                  <Button
                    key={q}
                    variant={ active ? "primary" : "bordered" }
                    size="lg"
                    onClick={() => setTab(q)}
                    className="rounded-lg"
                  >
                    {q}
                  </Button>
                );
              })}
            </div>
          </div>

          {/* Neighborhood grid, 6 columns on xl */}
          <div className="relative max-h-[320px] overflow-hidden px-5 py-6 sm:px-8">
            <div className="grid grid-cols-2 gap-x-6 gap-y-2 sm:grid-cols-3 lg:grid-cols-6">
              {columns.map((col, ci) => (
                <ul key={ci} className="flex flex-col gap-2">
                  {col.map((name, ni) => (
                    <li
                      key={`${ci}-${ni}`}
                      className="flex items-center gap-2 text-body-md font-medium text-text-primary"
                    >
                      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-blue-80" />
                      {name}
                    </li>
                  ))}
                </ul>
              ))}
            </div>

            <div
              className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-constant-white to-transparent"
              aria-hidden
            />
          </div>

          {/* Footer links */}
          <div className="grid grid-cols-1 divide-y sm:grid-cols-2 sm:divide-x sm:divide-y-0 divide-neutral-10 border-t border-neutral-10">
            <Link
              href="/search"
              className="flex items-center justify-center gap-1.5 py-4 text-body-md font-semibold text-blue-80 transition-colors"
            >
              Shop now
              <ChevronRightIcon size={14} className="text-blue-80" />
            </Link>
            <Link
              href="/account"
              className="flex items-center justify-center gap-1.5 py-4 text-body-md font-semibold text-blue-80 transition-colors"
            >
              Join the Dank club
              <ChevronRightIcon size={14} className="text-blue-80" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
